module.exports = __webpack_public_path__ + "static/media/signal-alt-1.f90ca696.svg";